// DS: i4.24
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Mail: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M14.999 6.646L15 13a1 1 0 01-1 1H2a1 1 0 01-1-1L.999 6.645 6.659 11H9.34L15 6.646zM14 2a1 1 0 011 1l-.001 1.117-.132.109L8.659 9H7.34L1.11 4.207l-.111-.073L1 3a1 1 0 011-1h12z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrap>
);
Mail.displayName = 'Mail';

export default Mail;
